import { Star, Check, Clock, ShieldCheck, Smartphone } from "lucide-react";
import { BookButton } from "@/components/common/BookButton";

// Sticky sidebar booking card used on ticket detail pages.
export const StickyBookingCard = ({ ticket }) => (
  <div
    data-testid="sticky-booking-card"
    className="rounded-2xl border border-stone-line bg-white p-6 shadow-soft md:p-7"
  >
    <div className="flex items-center gap-2 text-sm text-slatey">
      <Star size={15} className="fill-gold text-gold" />
      <span className="font-medium text-charcoal">{ticket.rating}</span>
      <span>· {ticket.reviews.toLocaleString()} reviews</span>
    </div>

    <div className="mt-4 flex items-end gap-2">
      <span className="text-sm text-slatey">From</span>
      <span className="font-serif text-4xl font-medium text-charcoal">€{ticket.price}</span>
      <span className="pb-1 text-sm text-slatey">per person</span>
    </div>

    <div className="mt-4 flex items-center gap-2 text-sm text-slatey">
      <Clock size={15} className="text-gold" />
      <span>{ticket.duration}</span>
    </div>

    <ul className="mt-5 space-y-2.5 border-t border-stone-line pt-5">
      {ticket.highlights.map((h, i) => (
        <li key={i} className="flex items-start gap-2.5 text-sm text-charcoal">
          <Check size={16} className="mt-0.5 shrink-0 text-gold" strokeWidth={2} />
          <span>{h}</span>
        </li>
      ))}
    </ul>

    <BookButton
      label="Book on GetYourGuide"
      size="lg"
      className="mt-6 w-full"
      testId="sticky-book-button"
    />

    <div className="mt-4 space-y-2 text-xs text-slatey">
      <div className="flex items-center gap-2">
        <ShieldCheck size={14} className="text-gold-dark" />
        <span>Free cancellation on most options</span>
      </div>
      <div className="flex items-center gap-2">
        <Smartphone size={14} className="text-gold-dark" />
        <span>Instant mobile ticket delivery</span>
      </div>
    </div>
  </div>
);

export default StickyBookingCard;
